module.exports = __webpack_public_path__ + "static/img/mix.4f2e051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mix.png
// module id = J0D8
// module chunks = 1